import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServiceStoreIds } from '../../api/parking-service.ts';
import { UpdateParkingServiceStoreIdsRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceStoreIds(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceStoreIds>>,
  Error,
  UpdateParkingServiceStoreIdsRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceStoreIds,
  });
}
